import ChatInterface from "../components/ChatInterface";
import "../components/ChatInterface.css";

const SUGGESTED = [
  "What is the Transformer architecture?",
  "Explain how diffusion models work",
  "What is Retrieval-Augmented Generation?",
  "How does constitutional AI work?",
  "What is the Mamba state space model?",
];

export default function Chat() {
  return (
    <div className="chat-page">
      {/* Header */}
      <div className="chat-page__header">
        <div className="container">
          <h1 className="chat-page__title">
            <span className="text-accent">✦</span> Ask Illumina
          </h1>
          <p className="chat-page__sub text-muted">
            Powered by Agentic RAG — answers are retrieved from arXiv papers,
            graded for relevance, and streamed with citations.
          </p>

          {/* Suggested prompts */}
          <div className="chat-page__suggestions">
            {SUGGESTED.map((s) => (
              <button
                key={s}
                className="btn btn-secondary chat-page__chip"
                onClick={() => {
                  // Dispatch a custom event that ChatInterface listens to
                  window.dispatchEvent(
                    new CustomEvent("ai:suggest", { detail: s }),
                  );
                }}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Actual chat */}
      <ChatInterface />

      <style>{`
        .chat-page {
          display: flex;
          flex-direction: column;
          height: calc(100vh - var(--nav-height));
          overflow: hidden;
        }
        .chat-page__header {
          border-bottom: 1px solid var(--border);
          padding: var(--space-md) 0;
          flex-shrink: 0;
        }
        .chat-page__title {
          font-size: 1.3rem;
          margin-bottom: var(--space-xs);
        }
        .chat-page__sub {
          font-size: 0.85rem;
          margin-bottom: var(--space-md);
        }
        .chat-page__suggestions {
          display: flex;
          flex-wrap: wrap;
          gap: var(--space-xs);
        }
        .chat-page__chip {
          font-size: 0.78rem;
          padding: 0.3rem 0.8rem;
          border-radius: var(--radius-full);
        }
      `}</style>
    </div>
  );
}
